// Assistant-facing descriptions stay in English, like the other surface context facts.
const EXPERIENCE_SEARCH_SORT_LABELS: Readonly<Record<Experiences.SortTypes, string>> = {
  type: 'Recommended',
  recommended: 'Recommended',
  'price.asc': 'Price (Lowest)',
  'price.desc': 'Price (Highest)',
  latest: 'Latest',
  endingsoon: 'Ending soon',
  bestValue: 'Best Value',
  customerRating: 'Customer Rating (Highest)',
  mostBooked: 'Most booked',
  mostViewed: 'Most viewed',
}

export function formatExperienceSearchSort(sort: Experiences.SortTypes): string {
  return EXPERIENCE_SEARCH_SORT_LABELS[sort]
}
